



import { useNavigate } from 'react-router-dom';
import HomeLf from './HomeLf';
import './pendenciaMaster.css';

import btn3 from '../assets/version2/btn3.png';
import msgicon from '../assets/version2/msgicon.png';
import send from '../assets/version2/send.png';
import { onAuthStateChanged } from 'firebase/auth';
import { db, firebaseAuth, storage } from '../utils/firebase-config';
import { useEffect, useState } from 'react';
import { collection, getDocs } from 'firebase/firestore';
import { getDownloadURL, ref, uploadBytes } from 'firebase/storage';
import logo from '../assets/version2/logo.png'
import Rodape from './Rodape';

var runtime = 0;
function PendenciaMaster() {


const navigate = useNavigate();



  const [current, setCurrent] = useState('');
  const [currentData, setCurrentData] = useState([]);
  const [url01, setUrl01] = useState();


  const queryParameters = new URLSearchParams(window.location.search)
  const parametroId = queryParameters.get("prjid");
  const parametroId2 = queryParameters.get("ordem");
  const parametroId3 = queryParameters.get("emaill");
  const [hide, setHide] = useState('none');
  const [mapeA, setMapeA] = useState([1]);
  const [countMp, setCountMp] = useState(0);
  const [dataMaster, setDataMaster] = useState([]);
  const [forSelect, setForSelect] = useState([]);
  const [nomeEmail, setNomeEmail] = useState([]);
  const [nome, setNome] = useState('');

  const [editOn, setEditOn] = useState(false);



    const uploadFile = async (params) => {
        if (!params) return;
      
       
          
       
        const imageRef = ref(storage, `clientesMidias/${current}/${params.name}`);

        uploadBytes(imageRef, params).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                setUrl01(url);
             
                enviarMsg(url);
            });
        }  );
 
    };





async function enviarMsg(params) {
  
const date = new Date();
const isoString = date.toISOString();



    var ligadoNotif = false;
    var listaNotif = [];
    listaNotif = currentData.emailsParticipantes;
    
    for (let i = 0; i < currentData.emailsParticipantes.length; i++) {
      
          if(currentData.emailsParticipantes[i].split('###master')[0].replaceAll(' ', '') == current.replaceAll(' ', '')){
              ligadoNotif = true;
          }  
    }

    if(ligadoNotif == true){
     listaNotif.push(currentData.criador);
    }

    


  fetch('https://apilumera.shop/api/mensagem', {
    method: 'POST',
    body: JSON.stringify({
      mensagem: document.querySelector('.inputprincipal').value,
      id: parametroId,
      ordem: parametroId2,
      remetente: nome,
      emailsParticipantes: listaNotif,
      dataHr: isoString,
      nomeProjeto: parametroId,
      nomeOrdem: parametroId2,
      url: params
    }),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {

      setUrl01('');
  window.location.reload();
     })
     .catch((err) => {
 
         setUrl01('');
window.location.reload();
     });




}







async function master(params) {

  var objMaster = [];
  var objMaster2 = [];
  var total = '';



 onAuthStateChanged(firebaseAuth, async (currentUser) => {
    if (currentUser) {
      var usuarioLogado = currentUser.email;
      setCurrent(usuarioLogado);



      
    };





  await fetch('https://apilumera.shop/api/consultaprojeto', {
      method: 'POST',
      body: JSON.stringify({
        id: parametroId,
  
      }),
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
    })
       .then((response) => response.json())
       .then((data) => {

          var projetoAtual = data;               
       
        setDataMaster(projetoAtual.colaboradores);
        setCurrentData(projetoAtual.ordens[parametroId2]);

        document.querySelector('.editInputNome').value = projetoAtual.ordens[parametroId2].nome;
        document.querySelector('.prioridade').value = projetoAtual.ordens[parametroId2].prioridade.toLowerCase();
      
     
        console.log('projetoAtual.ordens[parametroId2]', projetoAtual.ordens[parametroId2].participantes);

        setNome(total.nome);

        for (let i = 0; i < projetoAtual.ordens[parametroId2].participantes.length; i++) {
          console.log('parti ',projetoAtual.ordens[parametroId2].participantes[i].split('###master')[3].replaceAll(' ', ''))
          
          if(projetoAtual.ordens[parametroId2].participantes[i].split('###master')[0].replaceAll(' ', '') == usuarioLogado){
              setNome(projetoAtual.ordens[parametroId2].participantes[i].split('###master')[3].replaceAll(' ', ''));
          } 
          
        }

     var fortrade2 = [];
     var conta = 0;
     for (let i = 0; i < projetoAtual.ordens[parametroId2].participantes.length; i++) {
        conta = conta + 1;
        fortrade2.push(projetoAtual.ordens[parametroId2].participantes[i].split('###master')[3]);
            }
         setForSelect(fortrade2);


       })
       .catch((err) => {
          console.log(err.message);
       });





















  });










   





}





var trad = [];
var runtime = 0;

function mapear() {

  setCountMp(countMp + 1);

  for (let i = 0; i < countMp; i++) {
      trad.push(i);
  }
  trad.push(countMp);
  setMapeA(trad);


      

}



















var tradForSelect = [];






function enviarPost01() {


  function getObj(params) {

    for (let i = 0; i < dataMaster.length; i++) {
        if(dataMaster[i].split('###master')[3].replaceAll(' ', '') == params.replaceAll(' ', '')){
          return dataMaster[i];
        }
    }
}



var tradecolaboradores = [];
for (let i = 0; i < document.querySelectorAll('.colaboradores').length; i++) {
    tradecolaboradores.push(getObj(document.querySelectorAll('.colaboradores')[i].value.replaceAll(' ', '')))
  
}
  
  console.log('tradecolaboradores ',tradecolaboradores);

  var emailsColaboradores = [];

  for (let i = 0; i < tradecolaboradores.length; i++) {
    emailsColaboradores.push(tradecolaboradores[i].split('###master')[0]);
    
  }

  var nomeDaPendencia = document.querySelector('.inputNormal').value;
  var prioridadependencia = document.querySelector('.prioridade').value;









  fetch('https://apilumera.shop/api/editarordem', {
    method: 'POST',
    body: JSON.stringify(
{
      nomeOrdem: nomeDaPendencia,
      prioridade: prioridadependencia,
      dataatual: currentData.dataDeCriacao,
      email: currentData.criador,
      parametroId: parametroId,    
      participantes: tradecolaboradores,
      emailsParticipantes: emailsColaboradores,
      mensagens: currentData.mensagens,
      nomeProjeto: parametroId
     
    }
     
    ),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
        navigate(-1);
     })
     .catch((err) => {
      navigate(-1);
     });

  

}






function finalizarPost() {


  function getObj(params) {

    for (let i = 0; i < dataMaster.length; i++) {
        if(dataMaster[i].split('###master')[3].replaceAll(' ', '') == params.replaceAll(' ', '')){
          return dataMaster[i];
        }
    }
}



var tradecolaboradores = [];
for (let i = 0; i < document.querySelectorAll('.colaboradores').length; i++) {
    tradecolaboradores.push(getObj(document.querySelectorAll('.colaboradores')[i].value.replaceAll(' ', '')))
  
}
  
  console.log('tradecolaboradores ',tradecolaboradores);

  var emailsColaboradores = [];

  for (let i = 0; i < tradecolaboradores.length; i++) {
    emailsColaboradores.push(tradecolaboradores[i].split('###master')[0]);
    
  }

  var nomeDaPendencia = document.querySelector('.inputNormal').value;
  var prioridadependencia = document.querySelector('.prioridade').value;









  fetch('https://apilumera.shop/api/finalizarordem', {
    method: 'POST',
    body: JSON.stringify(
{
      nomeOrdem: nomeDaPendencia,
      prioridade: prioridadependencia,
      dataatual: currentData.dataDeCriacao,
      email: currentData.criador,
      parametroId: parametroId,    
      participantes: tradecolaboradores,
      emailsParticipantes: emailsColaboradores,
      mensagens: currentData.mensagens,
      nomeProjeto: parametroId
     
    }
     
    ),
    headers: {
      'Content-type': 'application/json; charset=UTF-8',
    },
  })
     .then((response) => response.json())
     .then((data) => {
        navigate(-1);
     })
     .catch((err) => {
      navigate(-1);
     });

  

}






useEffect(()=> {

  master();
},[])






















  return (
    <>


















<div style={{backgroundColor: 'rgba(100,100,100,0.5)', width: '100%', height: '100%', position: 'absolute',
 display: hide ,justifyContent: 'center', alignItems: 'center'

}}>


<div style={{ width: '500px',borderRadius: '16px', backgroundColor: '#fff', paddingBottom: '30px'}}>
<div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '10px',
paddingLeft: '20px', paddingRight: '20px',
alignItems: 'center'

}}>
<div><img src={logo} style={{width: '120px'}}></img></div>
<div>    <i class="bi bi-x" style={{fontSize: '25px', cursor: 'pointer'}}
onClick={()=> setHide('none')}
/>
</div>

</div>
<div>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-12" style={{borderRadius: '10px 10px 10px 10px', display: 'flex', fontSize: '16px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100, 100, 100, 0.02)', color: 'rgb(90, 90, 90)', fontWeight: 'bold'}}>Editar Pendência</div>
</div>

<div style={{padding: '0px 30px', marginTop: '30px'}}>
<div style={{fontWeight: 'bold', marginBottom: '2px'}}>Nome da pendência</div>
<div className="dastasColaboradores" style={{display: 'flex', marginBottom: '12px', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>
<input className='inputNormal editInputNome' style={{padding: '5px 5px', borderRadius: '5px', border: 'solid 1px rgb(100, 100, 100)'}} placeholder='Nome da pendência'></input>
</div>
<div style={{fontWeight: 'bold', marginBottom: '12px'}}>Colaboradores</div>
{!editOn && <>
<div className="dastasColaboradores" style={{display: 'flex', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>

{forSelect.map((data, index)=> {
return <>



<select className="colaboradores" style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', height: '35px', borderRadius: '10px', padding: '0px 14px'}}

>
  
    
      <option value={data} selected>{data}</option>
      


</select> 





</>
})}
<div>
  {editOn && <>
    <i class="bi bi-plus"
   style={{fontSize: '30px', cursor: 'pointer',
    lineHeight: '15px', color: 'rgb(6, 129, 6)'}}
    onClick={()=> mapear()}
    ></i>
  </>}
    {!editOn && <>
          <div style={{fontSize: '15px', color: 'rgb(90, 35, 35)', 
            paddingTop: '5px', fontWeight: '600', cursor: 'pointer'}}
            onClick={()=> {setEditOn(true); setMapeA([])}}
            >Editar</div>
    </>}

    </div>

</div>
</>}






{editOn && <>

<div className="dastasColaboradores" style={{display: 'flex', flexFlow: 'row wrap', gap: '10px', marginTop: '10px'}}>

{mapeA.map((data, index)=> {
return <>



<select className="colaboradores" style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', height: '35px', borderRadius: '10px', padding: '0px 14px'}}
>
  {dataMaster.map((data, index)=> {
    return <>
    
      <option value={data.split('###master')[3]}>{data.split('###master')[3]}</option>
    
    </>


  })}

</select>





</>
})}
<div>
  <i class="bi bi-plus"
   style={{fontSize: '30px', cursor: 'pointer',
    lineHeight: '15px', color: 'rgb(6, 129, 6)'}}
    onClick={()=> mapear()}
    ></i>
    </div>

</div>

</>}









<div>



</div>



<div style={{fontWeight: 'bold', marginBottom: '12px', marginTop: '15px'}}>Prioridade</div>
<select className="prioridade" style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', height: '35px', borderRadius: '10px', padding: '0px 14px'}}
>

<option value="baixa">Baixa</option>
<option value="media">Média</option>
<option value="alta">Alta</option>

</select>


</div>



<div style={{display: 'flex', justifyContent: 'end', alignItems: 'center', width: '100%', padding: '0px 30px', marginTop: '28px'}}>
        <div
         style={{width: '150px', height: '35px', 
          borderRadius: '10px', display: 'flex', 
          justifyContent: 'center', alignItems: 'center',
           fontWeight: '600', color: '#fff',
            backgroundColor: '#985EAC', cursor: 'pointer'}}
          onClick={()=> enviarPost01()}
        >Editar Pendência</div>
</div>

</div>



<div style={{display: 'none'}}>

<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-6" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: '#985EAC', color: '#fff'}}>Novo Projeto</div>
<div className="col-6" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(100,100,100,0.1)', color: 'black'}}>Colaboradores</div>
</div>



<div className="row" style={{ width: '100%', padding: '0px 30px', height: '35px', marginTop: '15px'}}>
<div className="col-7" style={{borderRadius: '10px 0px 0px 10px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center'}}>
    

<input style={{border: '1px solid #fff', backgroundColor: 'rgba(200,200,200, 0.2)', width: '100%', height: '35px', borderRadius: '10px', padding: '0px 14px'}} placeholder="Email do colaborador"></input>
</div>
<div className="col-5" style={{borderRadius: '0px 10px 10px 0px', display: 'flex', fontSize: '14px', justifyContent: 'center', alignItems: 'center', color: 'black'}}>
    <select style={{width: '100%', height: '35px', borderRadius: '10px'}}>
    <option value="Administrador"  style={{border: 'none'}}>Administrador</option>
  <option value="Gerente">Gerente</option>
  <option value="Engenheiro">Engenheiro</option>
  <option value="Prestador de serviços">Prestador de serviços</option>
    </select>

</div>
</div>






</div>






</div>

</div>













































<HomeLf/>



 
 <div className="row" style={{ marginTop: 50, padding: "0px 60px" }}>
  <div className="col-12 col-md-6">
    <a style={{ fontFamily: "Inter, serif", fontSize: 12, color: "#9095A1" }}>
      {currentData.nome}
    </a>
    <div style={{ display: "flex", marginTop: 5, alignItems: "center" }}>
      {" "}
      <img src={btn3} style={{ marginRight: 5 }} />{" "}
      <h4
        style={{
          fontFamily: "Archivo, serif",
          fontWeight: "bold",
          fontSize: 32
        }}
      >
        {currentData.nome}
      </h4>
    </div>
    <div
      style={{
        display: "flex",
        fontFamily: "Inter, serif",
        fontSize: 14,
        flexFlow: 'row wrap',
        color: "#9095A1",
        marginTop: 5
      }}
    >
      {" "}
      Prioridade:
      <div>



  {currentData.prioridade != undefined && <>
                        {currentData.prioridade.charAt(0).toUpperCase()+currentData.prioridade.slice(1) == 'Baixa' &&
                            <div
          className="red"
          style={{
           
            height: 24,
            backgroundColor: "#F1F8FD",
            borderRadius: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: '5px 5px',
            paddingRight: '7px',
            marginLeft: 5,
            marginRight: 10,
            color: '#379AE6'
          }}
        >
          <i
            className="bi bi-arrow-down-short"
            style={{ paddingBottom: 6, fontSize: 18 }}
          />
          <a style={{ paddingBottom: 2 }}>
          Baixa
              
             </a>
        </div>
                        
                        }
           
            </>}



  {currentData.prioridade != undefined && <>
                        {currentData.prioridade.charAt(0).toUpperCase()+currentData.prioridade.slice(1) == 'Media' &&
                            <div
          className="red"
          style={{
           
            height: 24,
            backgroundColor: "#FEF6F1",
            borderRadius: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: '8px',
            marginLeft: 5,
            padding: '5px 5px',
            marginRight: 10,
            color: '#AE530D'
          }}
        >
          <i
            className="bi bi-arrow-right-short"
            style={{ paddingBottom: 6, fontSize: 18 }}
          />
          <a style={{ paddingBottom: 2 }}>
          Média
            
             </a>
        </div>
                        
                        }
           
            </>}




  {currentData.prioridade != undefined && <>
                        {currentData.prioridade.charAt(0).toUpperCase()+currentData.prioridade.slice(1) == 'Alta' &&
                            <div
          className="red"
          style={{
            width: 45,
            height: 24,
            backgroundColor: "#FDF2F2",
            borderRadius: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            paddingRight: 5,
            marginLeft: 5,
            marginRight: 10,
            color: '#DE3B40'
          }}
        >
          <i
            className="bi bi-arrow-up-short"
            style={{ paddingBottom: 6, fontSize: 18 }}
          />
          <a style={{ paddingBottom: 2 }}>
          Alta
            
             </a>
        </div>
                        
                        }
           
            </>}











    
      </div>{" "}
      Status:{" "}
      <div>
        <div
          className="red"
          style={{
            height: 24,
            backgroundColor: `${currentData.status == "Finalizado" ? "#EEFDF3" : "#FEF9EE"}`,
            borderRadius: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: 70,
            paddingRight: 5,
            marginLeft: 5
          }}
        >
          <a style={{ paddingBottom: 2, color: `${currentData.status == "Finalizado" ? "#117B34" : "#98690C"}` }}>{currentData.status} </a>
        </div>
      </div>
      <div style={{ marginLeft: 14 }}>
        <i className="bi bi-calendar4" /> <a>
          {currentData.dataDeCriacao != undefined && <>
                    { currentData.dataDeCriacao.slice(8,10)+'/'+currentData.dataDeCriacao.slice(5,7)+'/'+currentData.dataDeCriacao.slice(0,4)}

          </>}
          
          </a>
      </div>{" "}
    </div>
    <div
      style={{
        display: "flex",
        fontFamily: "Inter, serif",
        fontSize: 14,
        color: "#9095A1",
        marginTop: 20
      }}
    >
      <i className="bi bi-person" style={{ marginRight: 8 }} />
      Solicitante:
      <div style={{ color: "#171A1F", marginLeft: 10 }}>{currentData.criador}</div>
      <div>
        <div
          className="red"
          style={{
            height: 24,
            backgroundColor: "#F3F4F6",
            borderRadius: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0px 10px",
            marginLeft: 8
          }}
        >
         
        </div>
      </div>{" "}
    </div>
    <div
      style={{
        display: "flex",
        fontFamily: "Inter, serif",
        fontSize: 14,
        color: "#9095A1",
        marginTop: 15
      }}
    >
      <i className="bi bi-person-circle" style={{ marginRight: 8 }} /> Atribuido
      a:
      <div style={{ display: "flex" }}>
        {currentData.participantes != undefined && <>
            {currentData.participantes.map((data, index)=> {
          return <>
          
             <div
          className="red"
          style={{
            height: 24,
            backgroundColor: "#F3F4F6",
            borderRadius: 14,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "0px 10px",
            marginLeft: 5
          }}
        >
          <a style={{ paddingBottom: 2, color: "#323743" }}>{data.split('###master')[1]}</a>
        </div>
          
          </>
        })
}
        </>}
    
     
       
      </div>{" "}
    </div>
    { currentData.status == 'Pendente' &&
 <div style={{ display: "flex", flexFlow: 'row wrap', marginTop: 15, gap: 10 }}>
      <div
        style={{
          backgroundColor: "#39AD5F",
          height: 20,
          fontFamily: "Inter, serif",
          color: "#fff",
          fontSize: 10,
          borderRadius: 10,
          padding: "0px 10px",
          display: "flex",
          alignItems: "center",
          cursor: 'pointer'
        }}
        onClick={()=> finalizarPost()}
      >
        <i className="bi bi-check-circle-fill" style={{ marginRight: 4 }} />
        Finalizar pendência
      </div>
      <div
        style={{
          border: "1px solid #574A69",
          height: 20,
          fontFamily: "Inter, serif",
          color: "#574A69",
          fontSize: 10,
          borderRadius: 10,
          padding: "0px 10px",
          display: "flex",
          alignItems: "center",
          cursor: 'pointer'
        }}
        onClick={()=> setHide('flex')}
      >
        <i className="bi bi-pencil" style={{ marginRight: 4 }} />
        Editar pendência
      </div>
    </div>
    }
   
    <div
      style={{
        display: "flex",
        fontFamily: "Inter, serif",
        fontSize: 14,
        color: "#000",
        marginTop: 12
      }}
    >
   {currentData.sobre}
    </div>
  </div>
  <div className="col-12 col-md-6">
    <div style={{ float: "right" }}>
      <div
        style={{
          border: "1px solid #574A69",
          height: 36,
          borderRadius: 10,
          display: "flex",
          alignItems: "center",
          padding: "0px 10px",
          cursor: 'pointer'
        }}
        onClick={()=> navigate(-1)}
      >
        <i className="bi bi-arrow-left-circle" style={{ marginRight: 8 }} />
        Voltar
      </div>
    </div>
    <div
      style={{
        border: "1px #DEE1E6 solid",
        borderRadius: 10,
        marginTop: 50,
        padding: "10px 20px",
        height: 679,
        display: "flex",
        flexFlow: "column",
        justifyContent: "space-between"
      }}
    >

    <div
          style={{
            display: "flex",
            fontFamily: "Archivo, serfi",
            borderBottom: "1px solid #F3F4F6",
            padding: "15px 0px",
            fontWeight: "bold",
            color: "#171A1F",
            fontSize: 20,
        
          }}
        >
          {" "}
          <img src={msgicon}/>{" "}
          <div style={{ marginLeft: 8 }}>Mensagens</div>
        </div>


      <div className="overflow"
     style={{    overflowY: 'scroll'}} 
      >
    









          {
            currentData.mensagens != undefined &&
            <>
            
           {currentData.mensagens.map((data, index)=> {
            return <>
                      <div style={{ marginBottom: 15 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginTop: 10,
              color: "#171A1F",
              fontSize: 12
            }}
          >
         {data.split('#####remetente:')[1].split('#####file:')[0]}
            <div
              style={{
                fontFamily: "Inter, serif",
                fontSize: 10,
                color: "#9095A1",
                borderLeft: "1px solid #DEE1E6",
                borderRight: "1px solid #DEE1E6",
                padding: "0px 10px",
                margin: "0px 10px"
              }}
            >
              {data.split('####data:')[1].replaceAll(' ', '').slice(0, 10).slice(8, 10)}/{data.split('####data:')[1].replaceAll(' ', '').slice(0, 10).slice(5, 7)}/{data.split('####data:')[1].replaceAll(' ', '').slice(0, 10).slice(0, 4)}
            </div>
            <div
              style={{
                fontFamily: "Inter, serif",
                fontSize: 10,
                color: "#9095A1"
              }}
            >
             {data.split('####data:')[1].replaceAll(' ', '').split('T')[1].slice(0, 5)}
            </div>
          </div>


          
          <div
            style={{
              backgroundColor: "#F8F9FA",
              borderRadius: 6,
              padding: "2px 8px",
              marginTop: 8,
              fontFamily: "Inter, serif",
              fontSize: 14
            }}
          >
         
              {data != undefined && <>
       
                 {data.split('#####remetente:')[0]} 
           {data.split('#####file:')[1] != undefined && <> 
           
                {data.split('#####file:')[1].split('#####data:')[0].replaceAll(' ', '') != 'undefined' && 

           <>
           <a style={{cursor: 'pointer', color: 'blue'}} 
           href={data.split('#####file:')[1].split('#####data:')[0].replaceAll(' ', '')}
           target="_blank"
           >Arquivo anexado</a>
               
           </>
           }
           
           </>}
      
            
        
      </>}
        
            
         
          </div>
        </div>
            
             </>
           })}

          


            </>

          }
        





































        
      </div>






      
      <div
        className="inputmsg"
        style={{
          borderTop: "1px solid #F3F4F6",
          margin: "18px 0px",
          paddingTop: 27
        }}
      >
    { currentData.status == 'Pendente' && 
         <div
          style={{
            fontFamily: "Inter, serif",
            fontSize: 16,
            width: "100%",
            padding: "0px 10px",
            borderRadius: 6,
            border: "#BDC1CA solid 1px",
            display: "flex",
            alignItems: "center",
            color: "#BDC1CA"
          }}
        >
          <input
            className="inputsemborda inputprincipal"
            style={{
              width: "100%",
              height: 50,
              border: "solid 1px transparent"
            }}
            placeholder="Escreva sua Mensagem..."
          />
          <div style={{ color: "#000", display: 'flex' }}>
            <label for="file-upload" class="custom-file-upload">
<i class="bi bi-upload" style={{fontSize: '25px', color: 'black', cursor: 'pointer'}}></i>
    </label>
         <input
   type="file"
   id="file-upload"
   onChange={(event) => {
    uploadFile(event.target.files[0]);
   }}
   />   <i class="bi bi-envelope" style={{fontSize: '25px', margin: '0px 10px', cursor: 'pointer'}}
    onClick={()=> enviarMsg()}
   ></i>
          </div>
        </div>
    }
   

      </div>
    </div>
  </div>
</div>


 <Rodape/>
  </>
  );
}

export default PendenciaMaster;






